import { render, staticRenderFns } from "./SpinnerIcon.vue?vue&type=template&id=189a6461&"
import script from "./SpinnerIcon.vue?vue&type=script&lang=js&"
export * from "./SpinnerIcon.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports